<section class="error-content-md">
    <cx-page-slot position="SideContent"></cx-page-slot>
    <button class="btn btn-primary" [routerLink]="'/'">
        {{ 'aimo.page.errors.404.action' | cxTranslate }}
    </button>
</section>
